/* eslint-disable no-restricted-imports */
import getValueByPathFromUnknown from 'integration/utils/getValueByPathFromUnknown';
import valueIsArray from 'integration/utils/typeAssertions/valueIsArray';
import valueIsArrayOfAssertion from 'integration/utils/typeAssertions/valueIsArrayOfAssertion';
import valueIsRecord from 'integration/utils/typeAssertions/valueIsRecord';
import valueIsString from 'integration/utils/typeAssertions/valueIsString';

export const extractPostalCode = (address: string) => {
	const postalCodeMatch = address.match(/\b\d{5}\b/);
	return postalCodeMatch ? postalCodeMatch[0] : null;
};

export const joinAddressLine = (addressLine: string[]) =>
	addressLine
		.map((line: string) =>
			line
				.split('|')
				.filter((part) => part.trim() !== '')
				.join(' ')
		)
		.filter((line: string) => line.trim() !== '')
		.join(', ');

export const generateAddressFullByUnknown = (deliveryAddress: unknown) => {
	if (!valueIsRecord(deliveryAddress)) {
		return null;
	}

	const addressLine = getValueByPathFromUnknown(deliveryAddress, ['addressLine']);

	if (!valueIsArray(addressLine)) {
		return null;
	}

	const cleanAddressLine = addressLine.filter((line) => valueIsString(line) && line.trim() !== '');

	if (!valueIsArrayOfAssertion(valueIsString)(cleanAddressLine)) {
		return null;
	}

	const splitAddressLine = joinAddressLine(cleanAddressLine);

	if (!splitAddressLine) {
		return null;
	}

	const physical = getValueByPathFromUnknown(deliveryAddress, ['physical']);
	const zipCode = getValueByPathFromUnknown(deliveryAddress, ['zipCode']);

	const zipCodeBase = valueIsString(physical)
		? extractPostalCode(physical)
		: valueIsString(zipCode)
		? zipCode
		: null;

	const baseStreet = zipCodeBase ? `${splitAddressLine}, C.P. ${zipCodeBase}` : splitAddressLine;

	const city = getValueByPathFromUnknown(deliveryAddress, ['city']);
	const state = getValueByPathFromUnknown(deliveryAddress, ['state']);

	if (valueIsString(state) && valueIsString(city)) {
		return `${baseStreet}, ${city}, ${state}`;
	}

	return baseStreet;
};
